exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#app {\n  height: 100%;\n  overflow-y: auto;\n}\n", ""]);

